import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  ConnectionReasonFormModelValue,
  RemoteDiagnosticsConnectionReasons,
  RemoteDiagnosticsConnectionReasonsControls,
} from './reasons-form.model';

@Component({
  selector: 'app-diagnostics-connection-reason-collector-form',
  templateUrl: './diagnostics-connection-reason-collector-form.component.html',
  styleUrls: ['./diagnostics-connection-reason-collector-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsConnectionReasonCollectorFormComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  protected reasonCollectorForm: FormGroup;
  protected RemoteDiagnosticsConnectionReasons = RemoteDiagnosticsConnectionReasons;
  protected RemoteDiagnosticsConnectionReasonsControls = RemoteDiagnosticsConnectionReasonsControls;

  readonly minlengthOfTicketNumber = 1;
  readonly maxlengthOfTicketNumber = 100;
  readonly ticketNumberPattern = /^[a-zA-Z0-9_-]*$/;

  readonly minlengthOfDescription = 1;
  readonly maxlengthOfDescription = 150;

  selectedReason: string;
  reasons: string[];

  @Output() formInvalid: EventEmitter<boolean> = new EventEmitter();
  @Output() formValue: EventEmitter<ConnectionReasonFormModelValue> = new EventEmitter();

  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef) {
    this.reasonCollectorForm = this.fb.group({
      [RemoteDiagnosticsConnectionReasonsControls.ReasonType]: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.reasonCollectorForm.valueChanges
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((value: ConnectionReasonFormModelValue) => {
        this.formInvalid.emit(this.reasonCollectorForm.invalid);
        this.formValue.emit(value);
      });

    this.reasons = Object.keys(RemoteDiagnosticsConnectionReasons);
  }

  onReasonChange(reason: string): void {
    this.selectedReason = reason;
    if (reason === RemoteDiagnosticsConnectionReasons.INSTALLER_SUPPORT) {
      this.addControlSafe(
        this.reasonCollectorForm,
        RemoteDiagnosticsConnectionReasonsControls.DescriptionText,
        new FormControl<string>('', [Validators.required])
      );
      this.removeControlSafe(
        this.reasonCollectorForm,
        RemoteDiagnosticsConnectionReasonsControls.TicketNumber
      );
    } else {
      this.addControlSafe(
        this.reasonCollectorForm,
        RemoteDiagnosticsConnectionReasonsControls.TicketNumber,
        new FormControl<string>('', [Validators.required])
      );
      this.removeControlSafe(
        this.reasonCollectorForm,
        RemoteDiagnosticsConnectionReasonsControls.DescriptionText
      );
    }
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  addControlSafe(form: FormGroup, controlName: string, formControl: FormControl): void {
    if (form.contains(controlName)) {
      return;
    }
    form.addControl(controlName, formControl);
  }

  removeControlSafe(form: FormGroup, controlName: string): void {
    if (form.contains(controlName)) {
      form.removeControl(controlName);
    }
  }
}
